<template>
  <div class="control-input">
    <select v-model="selected" @change="change()">
      <option v-for="option in optionsDisplay" v-bind:key="option.key" v-bind:value="option.value">{{ option.text }}</option>
    </select>
  </div>
</template>

<script>
  import Vue from 'vue';

  export default {
    name: 'VueSelectControl',
    props: ['readonly', 'emitter', 'ikey', 'getData', 'putData', 'options'],
    data: () => {
      return {
        selected: null,
      }
    },
    computed: {
      optionsDisplay() {
        return this.options;
      }
    },
    methods: {
      // The following method onChange() looks as if it is not used. This is NOT true.
      // This method is overwritten by the module, input and output components. Do not delete.
      onChange() {
        // console.log('onChange in Selector.')
      },
      change() {
        let context =  this;
        Vue.nextTick(() => {
          context.update();
          context.onChange(this.selected);
        })
      },
      update() {
        if (this.ikey)
          this.putData(this.ikey, this.selected)

        this.emitter.trigger('process');
      }
    },
    mounted() {
      let initialValue;

      if ( this.getData(this.ikey) ) {
        initialValue = this.getData(this.ikey);
      } 
      else if (this.options && this.options[0]) {
        initialValue = this.options[0].value;
      }

      this.selected = initialValue;
      this.change();
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /*.node .control-input {
    padding: 6px 18px;
  }*/
</style>
